import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { selectIsConfigStripOpen } from '@epicuro-next/state/config-strip-state';
import { select, Store } from '@ngrx/store';

import { IServicenowVirtualAgentConfig } from '../../interfaces/servicenow-virtual-agent.interface';
import { SERVICENOW_VIRTUAL_AGENT_CONFIG_TOKEN } from '../../tokens';

@Component({
  selector: 'epc-servicenow-virtual-agent',
  templateUrl: './servicenow-virtual-agent.component.html',
  styleUrls: ['./servicenow-virtual-agent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServicenowVirtualAgentComponent {
  public isConfigStripOpen$ = this.store.pipe(select(selectIsConfigStripOpen));
  public isOpen = false;
  public openedOnce = false;

  constructor(
    @Inject(SERVICENOW_VIRTUAL_AGENT_CONFIG_TOKEN)
    protected readonly servicenowVirtualAgentConfig: IServicenowVirtualAgentConfig,
    private readonly store: Store,
  ) {}

  protected toggleOpenClose(): void {
    if (!this.isOpen && !this.openedOnce) {
      this.openedOnce = true;
    }
    this.isOpen = !this.isOpen;
  }
}
